
import React from 'react';
import {Modal} from 'react-bootstrap'
import { LessonplanSlotPicker } from '../../_components/lessonplan-slot-picker';

// @Component({
//   selector: 'app-modal-lessonplan-slot-picker',
//   templateUrl: './modal-lessonplan-slot-picker.component.html',
//   styleUrls: ['./modal-lessonplan-slot-picker.component.css']
// })

interface MyProps {
    my_modal_title:string;
    my_modal_content:string;
    activitySlots:any;
    getActivitySlot:any;
}

interface MyState {
    show_modal:boolean
}
export class ModalLessonplanSlotPicker extends React.Component<MyProps,MyState> {

    state:MyState= {
        show_modal:true,
    }
  message: any = { show: 0, data: "", type: 0 };
  result: any;
 
  constructor(props:MyProps) {
    //this.batchDisplayName = this.globalVars.CONFIG.batchDisplayName;    
    super(props)
    this.result = {activitySlot:null, size:0};
    console.log("kavya")
  }

  componentDidMount(): void {
    //this.getInstructorBatches(this.batches);
    console.log('in lessonplanslotpicker')
    console.log(this.props.activitySlots)
  }
  closeModal(reason){
    this.setState({show_modal:false})
    return reason
  }
  onSelectActivitySlot =(activitySlot:any):void=> {
    //alert(JSON.stringify(batch));
    this.result = {activitySlot:activitySlot, size:this.props.activitySlots.length};
    console.log('onSelectBatch : '+this.result);
    this.props.getActivitySlot(activitySlot)
    this.closeModal(this.result);
    //this.viewCtrl.dismiss(this.result);
  }

  /*getInstructorBatches(batches: any) {
    console.log("getInstructorBatches()..:  "+batches);
    
  }*/

  render(){
      return(
            <Modal show={this.state.show_modal}>
                <Modal.Header>
                    <Modal.Title className="modal-title">{this.props.my_modal_title}</Modal.Title>
                    <button type="button" className="close" aria-label="Close" onClick={() => this.closeModal('Cross click')}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <LessonplanSlotPicker activitySlots={this.props.activitySlots} notify={this.onSelectActivitySlot}></LessonplanSlotPicker>
                </Modal.Body>
            </Modal>
      )
  }

}
